module.exports = __webpack_public_path__ + "static/shop-showcase-18a9f6d62468fb2060e5b74a1c54f1c6.jpeg";